module.exports = __webpack_public_path__ + "img/e438d54.png";